import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAgency } from '../../api/apiAgencies';
import toast from 'react-hot-toast';
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

export const useUpdateAgency = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateAgencyMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateAgency(id, data),
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['agencies'] });
            queryClient.invalidateQueries({ queryKey: ['agency'] });
            toast.success(data.message || 'Agency updated successfully');
            navigate('/agencies');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || 'Failed to update agency');
        },
    });

    return {
        updateAgencyMutate,
        isPending,
    };
};
